import React from 'react';
import {
  HeroContainer,
  ContentWrapper,
  TextContent,
  ImageWrapper,
  CTAButton,
  GlassOverlay
} from './HeroSection.styles';
import herBackground from '/images/hero.svg';
import CollectionOfStaffWithPatients from '/images/CollectionOfPeople.jpg';
import { Container } from '../../../theme/globalStyles';

const HeroSection: React.FC = () => {
  return (
    <HeroContainer $backgroundImage={herBackground}>
      <Container>
        <GlassOverlay>
          <ContentWrapper>
            <TextContent>
              <h2 className="hero-heading">
                <span className="line-1">Ending Health Related Suffering</span>
                <span className="line-2">through</span>
                <span className="fancy-text">Compassionate Care</span>
              </h2>
              <div>
                <CTAButton $primary to="/donate">
                  Donate Now
                </CTAButton>
                <CTAButton to="/about">
                  Learn More
                </CTAButton>
              </div>
            </TextContent>
            <ImageWrapper>
              <img 
                src={CollectionOfStaffWithPatients} 
                alt="Healthcare professional providing compassionate care" 
              />
            </ImageWrapper>
          </ContentWrapper>
        </GlassOverlay>
      </Container>
    </HeroContainer>
  );
};

export default HeroSection;